import React, { useEffect, useState } from "react";
import { X } from "react-feather";

// internal rebet imports
import "./stylesAppStoreWrittenReviewPopup.css";

// component imports
import RebetLoader from "../../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../../api/ApiRoutes";

import { message, Popconfirm } from "antd";
import ToggleSwitch from "../../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import { fetchSpecificUsersData } from "../../../../../../api/CommonFunctions/CommonFunctions";

const AppStoreWrittenReviewPopup = ({
  isVisible,
  onClosePressed,
  userId,
  userData,
}) => {
  // non-state variables
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    false
  );
  // state variables
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [toggleOptions, setToggleOptions] = useState([]);

  const handleToggleChange = async (updatedFlag) => {
    const updatedOption = !updatedFlag.status;

    const payload = {
      user_id: userData.user_id,
      wrote_appstore_review: updatedOption,
    };

    try {
      const res = await PrivateAdminPanelInstance.post(
        API_ROUTES.UPDATE_USER_APPSTORE_REVIEW_STATUS,
        payload
      );

      setToggleOptions((prevOptions) =>
        prevOptions.map((option, index) => {
          if (index === prevOptions.length - 1) {
            return { ...option, status: updatedOption };
          }
          return option;
        })
      );

      messageApi.success(res.data.message);
    } catch (error) {
      messageApi.error("Failed to update feature flag.");
      console.error("Update error:", error);
    }
  };

  const getNewestUserData = async () => {
    if (!userId) return;
    
    const newestUserData = await fetchSpecificUsersData(
      PrivateAdminPanelInstance,
      userId
    );
    console.log("newestUserData", newestUserData);
    setToggleOptions([
      {
        id: 1,
        name: `Did ${newestUserData.username} leave a written review on the app store?`,
        status: newestUserData.wrote_appstore_review ?? false,
      },
    ]);
  };

  useEffect(() => {
    getNewestUserData();
  }, [userData]);

  const handleClosePressed = () => {
    onClosePressed();
  };

  if (!isVisible) return null;

  return (
    <div className="suspend-user-popup app-store-written-popup">
      {contextHolder}
      <div className="suspend-user-panel">
        {isApiRunning ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="suspend-user-header">
              <div className="suspend-user-header-label">
                App Store Written Review
              </div>
              <button className="close-button" onClick={handleClosePressed}>
                <X className="close-icon" />
              </button>
            </div>
            <div className="app-store-written-container">
              {toggleOptions.map((option) => (
                <div key={option.id} className="feature-flag-item">
                  <div className="feature-flag-label">{option.name}</div>
                  <div className="app-store-written-toggle-container">
                    <span
                      className={`app-store-written-toggle-status ${
                        option.status ? "enabled" : "disabled"
                      }`}
                    >
                      {option.status ? "Yes" : "No"}
                    </span>
                    <div className="feature-flag-value">
                      <ToggleSwitch
                        status={option.status}
                        eventCode={option.id}
                        updateEventCode={handleToggleChange}
                        data={option}
                        onlyUpdate={true}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AppStoreWrittenReviewPopup;
